// packages/apps/client/src/components/home/home-slider.tsx
import { Carousel, CarouselContent, CarouselItem } from '@ui/carousel.tsx';
import Autoplay from 'embla-carousel-autoplay';
import { Button } from '@ui/button.tsx';
import { LinkProtected } from '@r/components/link-protected/link-protected.tsx';
import { cn } from '@r/utils/utils.ts';
import { useTranslation } from 'react-i18next';

type HomeSliderProps = {
  programSlides: string[];
  defaultSlide: string;
};

function HomeSlider({ programSlides, defaultSlide }: HomeSliderProps) {
  const { t } = useTranslation();

  return (
    <div className="flex overflow-hidden relative flex-col justify-between w-full h-full border-0 grow">
      <Carousel
        className="h-full min-h-[350px]"
        opts={{
          loop: true,
          watchDrag: false
        }}
        plugins={[
          Autoplay({
            delay: 7000
          })
        ]}
      >
        <CarouselContent className="ml-0 w-full h-full">
          {programSlides?.map((slideUrl, i) => (
            <CarouselItem key={i} className="relative pl-0 home-carousel-item">
              <div className="flex absolute top-0 left-0 justify-center items-center w-full h-full">
                <img
                  src={slideUrl || defaultSlide}
                  alt=""
                  className="object-cover object-center w-full min-h-full"
                  onError={(e) => {
                    e.currentTarget.src = defaultSlide;
                    e.currentTarget.onerror = null;
                  }}
                />
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
      <div className="flex absolute flex-col justify-between p-7 w-full h-full">
        <div className="absolute top-0 left-0 w-full h-full opacity-25 bg-foreground" />
        <h1 className={cn('z-10 w-full text-3xl font-bold text-primary-foreground lg:w-8/12')}>
          {t('home.program.link.text')}
        </h1>
        <div className="z-10">
          <LinkProtected to="/program">
            <Button onClick={() => {}} variant="outline" rounded="full">
              {t('homepage.program.link')}
            </Button>
          </LinkProtected>
        </div>
      </div>
    </div>
  );
}

export { HomeSlider };
